import leosaBlue from "../../../images/badges/leosaPolicy/shield_blue.png";

const LeosaBlue = ({ imageProps }: any) => {
  return <img src={leosaBlue} alt="leosa-positive" {...imageProps} />;
};

export default LeosaBlue;
